import config from '@/config';

import axiosInstance from '@/utils/api-new';
import UserUtils from '@/utils/user';
import { UserState } from '@/types/user';

export const levelTestService: any = {
  fetchLevelTestQuestions: async (user: UserState) => {
    const resp: any | null = await axiosInstance.get(
      `${config.apiVersion}/level-test/${UserUtils.fromToLanguage(user)}/level-test-questions/${user.id}`
    );
    return resp;
  },
  postLevelTestResult: async (user: UserState, result: any) => {
    const resp = await axiosInstance.post(
      `${config.apiVersion}/level-test/${UserUtils.fromToLanguage(user)}/update-result/${user.id}`,
      result
    );
    return resp.data.data;
  },
};
